import GenericDB from './generic-db'

export default class FbAdzCallToActionsDB extends GenericDB {
  constructor() {
    super('fbAdzCallToActions')
  }

  // Here you can extend FbAdzCallToActionsDB with custom methods
}
